import { BaseDto } from 'src/dtos/common/baseDto';

/** 사원별 근무조 배정 기간과 편집 상태이다. */
export interface HrmEmpShiftDto extends BaseDto {
    empNo: string; // 사원번호
    startDt: string; // 적용시작일
    endDt: string; // 적용종료일, 빈 값은 계속 적용
    assignType: string; // FIX 또는 ROT
    shiftCd: string; // 고정 근무조 코드
    rotGroup: string; // 교대 A/B조
    remark: string; // 비고
    inserted: boolean; // 저장되지 않은 행이면 true
    isModified: boolean; // 조회 후 수정했으면 true
}

/** 근무조 배정 신규 행의 기본값이다. */
export const defaultHrmEmpShiftDto: HrmEmpShiftDto = {
    valueIndex: 0, orderIndex: 0, orderIndexSeq: 0,
    empNo: '', startDt: '', endDt: '', assignType: 'FIX', shiftCd: 'D',
    rotGroup: '', remark: '', inserted: false, isModified: false,
};
